(function() {
    'use strict';
    angular
        .module('teJHipsterApp')
        .factory('HandbookFolder', HandbookFolder);

    HandbookFolder.$inject = ['$resource'];

    function HandbookFolder ($resource) {
        var resourceUrl =  'api/handbook-folders/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
